// ABOUTME: Spinner shown by Suspense while lazy route chunks are loading
// ABOUTME: Plain card with spinner; matches the empty-state cards used elsewhere

import { CircleNotch } from '@phosphor-icons/react';

export function RouteLoader() {
  return (
    <div className="card text-center py-16">
      <div className="flex justify-center mb-4">
        <CircleNotch
          className="animate-spin h-12 w-12 text-primary-600"
          weight="bold"
          aria-hidden="true"
        />
      </div>
      <h3 className="text-lg font-semibold text-slate-900 mb-2">Loading…</h3>
    </div>
  );
}
